var staticLocation = require('./staticLocation')

var helperGetLocatOrigin = require('./helperGetLocatOrigin')

var lastIndexOf = require('./lastIndexOf')

function getBaseURL () {
  if (staticLocation) {
    var pathname = staticLocation.pathname
    var lastIndex = lastIndexOf(pathname, '/') + 1
    return helperGetLocatOrigin() + (lastIndex === pathname.length ? pathname : pathname.substring(0, lastIndex))
  }
  return ''
}

module.exports = getBaseURL



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/getBaseURL.js
// module id = 1158
// module chunks = 75